import { render } from "./LineTabs.vue?vue&type=template&id=7ab2bb02"
import script from "./LineTabs.vue?vue&type=script&lang=ts"
export * from "./LineTabs.vue?vue&type=script&lang=ts"
script.render = render

export default script